module.exports = __webpack_public_path__ + "img/thumbnail_Caracal_m_normal.913c0abd.png";